/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteUserRequest
 */
export interface DeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteUserRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the DeleteUserRequest interface.
 */
export function instanceOfDeleteUserRequest(value: object): value is DeleteUserRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function DeleteUserRequestFromJSON(json: any): DeleteUserRequest {
    return DeleteUserRequestFromJSONTyped(json, false);
}

export function DeleteUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

  export function DeleteUserRequestToJSON(json: any): DeleteUserRequest {
      return DeleteUserRequestToJSONTyped(json, false);
  }

  export function DeleteUserRequestToJSONTyped(value?: DeleteUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
    };
}

